import React from 'react';

const ReferalIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.586 2.66667H10.4127C5.55935 2.66667 2.66602 5.56 2.66602 10.4133V21.5733C2.66602 26.44 5.55935 29.3333 10.4127 29.3333H21.5727C26.426 29.3333 29.3193 26.44 29.3193 21.5867V10.4133C29.3327 5.56 26.4394 2.66667 21.586 2.66667ZM25.3327 10.9867C25.3327 11.72 24.7327 12.32 23.9993 12.32H21.3327C20.786 12.32 20.3327 12.7733 20.3327 13.32C20.3327 13.88 20.786 14.32 21.3327 14.32H23.9993C24.7327 14.32 25.3327 14.92 25.3327 15.6533V16.3333C25.3327 17.0667 24.7327 17.6667 23.9993 17.6667H21.3327C20.786 17.6667 20.3327 18.12 20.3327 18.6667C20.3327 19.2133 20.786 19.6667 21.3327 19.6667H23.9993C24.7327 19.6667 25.3327 20.2667 25.3327 21V21.3333C25.3327 23.5467 23.546 25.3333 21.3327 25.3333H10.666C8.45268 25.3333 6.66602 23.5467 6.66602 21.3333V20.6667C6.66602 19.9333 7.26602 19.3333 7.99935 19.3333H9.97268C11.9327 19.3333 13.4927 17.6533 13.2927 15.6533C13.1193 13.92 11.5327 12.6667 9.78602 12.6667H7.99935C7.26602 12.6667 6.66602 12.0667 6.66602 11.3333V10.6667C6.66602 8.45334 8.45268 6.66667 10.666 6.66667H21.3327C23.546 6.66667 25.3327 8.45334 25.3327 10.6667V10.9867ZM6.66602 16C6.66602 15.2667 7.26602 14.6667 7.99935 14.6667H9.33268C10.066 14.6667 10.666 15.2667 10.666 16C10.666 16.7333 10.066 17.3333 9.33268 17.3333H7.99935C7.26602 17.3333 6.66602 16.7333 6.66602 16Z",
      fill: "#0072B1"
    }
  )
);
ReferalIcon.displayName = "Icons.ReferalIcon";

export { ReferalIcon };
//# sourceMappingURL=ReferalIcon.js.map
